import React from 'react';
import PropTypes from 'prop-types';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FooterButtons } from 'site-modules/lease-deals/components/filters/shell/footer-buttons/footer-buttons';
import { Loading } from 'site-modules/lease-deals/components/loading/loading';

import './filter-layout.scss';

export function FilterLayout({ toggle, children }) {
  const closeButton = (
    <button className="display-lg border-0 bg-transparent py-0 px-0_25" aria-label="Close" onClick={toggle}>
      <i className="icon-cross2 text-cool-gray-40 align-middle" aria-hidden="true" />
    </button>
  );

  const cssModule = {
    'modal-title': 'size-20 fw-medium text-cool-gray-30 flex-grow-1 text-center mb-0',
    'modal-footer': 'd-flex justify-content-between px-1_5 py-0_75 align-items-center',
  };

  return (
    <>
      <Loading />
      <ModalHeader tag="h2" className="px-1_5 py-0_75" close={closeButton} cssModule={cssModule}>
        Filters
      </ModalHeader>

      <ModalBody className="py-1 px-0 d-flex flex-column">{children}</ModalBody>

      <ModalFooter cssModule={cssModule} className="footer-shadow">
        <FooterButtons toggle={toggle} />
      </ModalFooter>
    </>
  );
}

FilterLayout.propTypes = {
  children: PropTypes.node.isRequired,
  toggle: PropTypes.func.isRequired,
};
